import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FeedbackAndHelp } from './feedback-and-help';
import { MoreMenuItem } from './more-menu-item';
import {
  StyledBottomSheet,
  StyledList,
  StyledMeta,
  StyledDivider,
  StyledListLast,
} from './more-menu.styles';

const MoreMenu = ({
  show,
  onOutsideClick,
  navigationItems,
  upsellItems,
  extraItems,
  isMarketingEntry,
  hashedUserId,
}) => {
  const getMoreMenuItem = (item) => <MoreMenuItem item={item} key={item.key} />;
  return (
    <StyledBottomSheet
      key="sheet"
      dimmerTitle="close"
      onOutsideClick={onOutsideClick}
      show={show}
      data-qa="more-menu"
    >
      {isMarketingEntry ? (
        <React.Fragment>
          <FeedbackAndHelp
            onClick={onOutsideClick}
            hashedUserId={hashedUserId}
          />
          <StyledDivider key="divider-1" />
        </React.Fragment>
      ) : (
        <StyledMeta size="small">
          <FormattedMessage id="FRAME_NAVIGATION_UPSELL_HEADLINE" />
        </StyledMeta>
      )}
      <StyledList key="upsellItems">
        {upsellItems.map(getMoreMenuItem)}
      </StyledList>
      <StyledDivider key="divider-2" />
      <StyledList key="navigationItems">
        {navigationItems.map(getMoreMenuItem)}
      </StyledList>
      <StyledDivider key="divider-3" />
      <StyledListLast key="extraItems">
        {extraItems.map(getMoreMenuItem)}
      </StyledListLast>
    </StyledBottomSheet>
  );
};

MoreMenu.displaName = 'MoreMenu';

MoreMenu.defaultProps = { show: false };
MoreMenu.propTypes = {
  show: PropTypes.bool.isRequired,
  navigationItems: PropTypes.array.isRequired,
  upsellItems: PropTypes.array.isRequired,
  extraItems: PropTypes.array.isRequired,
  onOutsideClick: PropTypes.func.isRequired,
  isMarketingEntry: PropTypes.bool.isRequired,
  hashedUserId: PropTypes.string,
};

export { MoreMenu };
